export default __webpack_public_path__ + "static/media/7daa9d656fba57e3.8fe0a172eea700fc6d2021bab601e7c6.svg";